import templateUrl from 'emun.prospect/prospect-performance-region.htm'
class ProspectPerformanceRegionController {
    constructor($window, $rootScope, retailerPrompt, createAutoQuery) { 
        let $ctrl = this;
        $ctrl.regions = [];

        $ctrl.regionsQuery = createAutoQuery({
            url: 'QueryRegions.json',
            orderBy: 'Name',
            autoLoad: true,
            pageSize: 1000,
            onLoaded: function(regions) {
                regions.results.forEach(function(region) {
                    $ctrl.regions.push({
                        id: region.id,
                        label: region.name,
                        conversionRate: 0,
                        statusNew: 0,
                        statusOpen: 0,
                        statusConverted: 0
                    })
                });

                $ctrl.prospectQuery = createAutoQuery({
                    url: 'QueryProspectsJoin.json?dateRange=' + $ctrl.daterange + '&Count=Id&GroupBy=RegionId,Status',
                    autoLoad: true,
                    pageSize: 1000,
                    onLoaded: function(totals) {
                        totals.results.forEach(function(total) {
                            $ctrl.regions.forEach(function(region) {
                                if (region.id == total.regionId) {
                                    if (total.status == 'Active') {
                                        region.statusOpen += total.Total;
                                    } else if (total.status == 'Converted') {
                                        region.statusConverted += total.Total;
                                    }
                                    region.statusNew += total.Total;
                                    region.conversionRate = Math.round((region.statusConverted / region.statusNew) * 100);
                                }
                            });
                        });
                    }
                });
            }
        });
    }
}

let ProspectPerformanceRegion = {
    bindings: {
        daterange: '@'
    },
    controller: ProspectPerformanceRegionController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}


export default ProspectPerformanceRegion